import axios from 'axios';

// The axios implementation for keepAlive is behaving unreliably, so
// these utils are specifically for when that behaviour is needed
export const FetchUtils = {
  fetchWithKeepAlive(url: string, method: string, body?: string) {
    fetch(`${process.env.BASE_URL}api/${url}`, {
      keepalive: true,
      method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${axios.defaults.headers.common.Authorization}`,
        'SessionId': axios.defaults.headers.SessionId
      },
      body
    });
  },
  deleteWithKeepAlive(url: string) {
    this.fetchWithKeepAlive(url, 'DELETE');
  }
};